import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatButtonContext = createContext();

export const useChatButton = () => {
  const context = useContext(ChatButtonContext);
  if (!context) {
    throw new Error('useChatButton must be used within a ChatButtonProvider');
  }
  return context;
};

export const ChatButtonProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSymbol, setCurrentSymbol] = useState({ scrip: 'NIFTY' });

  const showChatButton = useCallback((symbol = { scrip: 'NIFTY' }) => {
    setCurrentSymbol(symbol);
    setIsVisible(true);
  }, []);

  const hideChatButton = useCallback(() => {
    setIsVisible(false);
  }, []);

  const value = {
    isVisible,
    currentSymbol,
    showChatButton,
    hideChatButton,
  };

  return (
    <ChatButtonContext.Provider value={value}>
      {children}
    </ChatButtonContext.Provider>
  );
};
